import { getAxiosClient } from "../../axios-client";
import { ChangePasswordRequestBody, ChangePasswordResponse } from "./types";
const axiosClient = getAxiosClient();

export const changePassword = async (body: ChangePasswordRequestBody) => {
    return await axiosClient.ax.put<ChangePasswordResponse>("/Account/ChangePassword", body);
};
